import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    width: '100%',
  },
  documentItem: {
    border: '1px solid #EEEEEE',
    borderRadius: 4,
    cursor: 'pointer',
    marginBottom: 16,
    padding: '16px 14px',
  },
  name: {
    whiteSpace: 'wrap',
  },
  loadingContainer: {
    height: 150,
    width: '100%',
  },
  button: {
    fontSize: theme.typography.pxToRem(13),
    textTransform: 'capitalize',
  },
  icon: {
    alignItems: 'center',
    backgroundColor: theme.palette.documents.defaultBg,
    borderRadius: 2,
    color: theme.palette.documents.default,
    display: 'flex',
    justifyContent: 'center',
    height: 20,
    width: 20,
    '& svg': {
      fontSize: theme.typography.pxToRem(13),
    },
  },
  arrowIcon: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(14),
    marginLeft: 8,
  },
  iconAPPROVED: {
    backgroundColor: theme.palette.documents.approvedBg,
    color: theme.palette.documents.approved,
  },
  iconPENDING: {
    backgroundColor: theme.palette.documents.pendingBg,
    color: theme.palette.documents.pending,
  },
  iconUPLOADED: {
    backgroundColor: theme.palette.documents.uploadedBg,
    color: theme.palette.documents.uploaded,
  },
  iconDECLINED: {
    backgroundColor: theme.palette.documents.declinedBg,
    color: theme.palette.documents.declined,
  },
  iconEXPIRED: {
    backgroundColor: theme.palette.documents.expiredBg,
    color: theme.palette.documents.expired,
  },
}));

export default useStyles;
